import { useParams } from 'react-router';

import { useQuery } from '@tanstack/react-query';

import { useRequestListagem } from 'hooks/useRequestListagem';
import { ConfigPedidoQuebrasDinamicas } from 'pages/compra/configuracao-pedido/types';

export function useQueryQuebrasDinamicas() {
    const requestListagem = useRequestListagem();
    const { id } = useParams();

    return useQuery<ConfigPedidoQuebrasDinamicas>({
        queryKey: ['config-pedido-quebras-dinamicas', id],
        queryFn: () =>
            requestListagem({
                url: `/gestao/configpedidoquebra/configpedido/${id}`,
                sort: [
                    { property: 'idConfigPedidoQuebra', direction: 'ASC' },
                    { property: 'nrQuebra', direction: 'ASC' },
                ],
            }).then((res) => ({ configPedidoQuebrasDinamicas: res.data })),
    });
}
